import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DraftArray } from 'types/draftArray';
import { format } from 'date-fns';

interface MeteorologyWeatherComparatorControlPanelState {
  area: string | undefined;
  dates: DraftArray<string>;
  variable: string | undefined;
  model: DraftArray<string>;
  modelPeriods: { startDate: string | null; endDate: string | null }[];
  triggerFetch: (() => void) | undefined;
}

const defaultRoundDate = format((new Date()).setDate(1), 'yyyy-MM-dd');
const defaultModelPeriod = format(new Date(), 'yyyy-MM');

const initialState: MeteorologyWeatherComparatorControlPanelState = {
  area: undefined,
  dates: [defaultRoundDate, defaultRoundDate],
  variable: undefined,
  model: [undefined, undefined],
  modelPeriods: [
    { startDate: defaultModelPeriod, endDate: defaultModelPeriod },
    { startDate: defaultModelPeriod, endDate: defaultModelPeriod },
  ],
  triggerFetch: undefined,
};

export const meteorologyWeatherComparatorControlPanelSlice = createSlice({
  name: 'meteorologyWeatherComparatorControlPanel',
  initialState,
  reducers: {
    reset: (state) => {
      Object.assign(state, initialState);
    },
    setArea: (state, action: PayloadAction<string | undefined>) => {
      state.area = action.payload;
    },
    setDates: (state, action: PayloadAction<(string | undefined)[]>) => {
      state.dates = action.payload;
    },
    setVariable: (state, action: PayloadAction<string | undefined>) => {
      state.variable = action.payload;
    },
    setModel: (state, action: PayloadAction<(string | undefined)[]>) => {
      state.model = action.payload;
    },
    setModelPeriods: (state, action: PayloadAction<{ startDate: string; endDate: string }[]>) => {
      state.modelPeriods = action.payload;
    },
    setTriggerFetch: (state, action: PayloadAction<(() => void) | undefined>) => {
      state.triggerFetch = action.payload;
    },
  },
});

export const selectMWComparatorControlPanelArea = (state: any) => (
  state.meteorologyWeatherComparatorControlPanel.area
);

export const selectMWComparatorControlPanelDates = (state: any) => (
  state.meteorologyWeatherComparatorControlPanel.dates
);

export const selectMWComparatorControlPanelVariable = (state: any) => (
  state.meteorologyWeatherComparatorControlPanel.variable
);

export const selectMWComparatorControlPanelModel = (state: any) => (
  state.meteorologyWeatherComparatorControlPanel.model
);

export const selectMWComparatorControlPanelModelPeriods = (state: any) => (
  state.meteorologyWeatherComparatorControlPanel.modelPeriods
);

export const selectMWComparatorControlPanelTriggerFetch = (state: any) => (
  state.meteorologyWeatherComparatorControlPanel.triggerFetch
);

export const {
  reset,
  setArea,
  setDates,
  setVariable,
  setModel,
  setModelPeriods,
  setTriggerFetch,
} = meteorologyWeatherComparatorControlPanelSlice.actions;

export default meteorologyWeatherComparatorControlPanelSlice.reducer;
